/**
 * @author Yaochao
 * @date 2021/7/23 9:47
 * @description
 */
import React from 'react';
import Loadable from 'react-loadable';
import {Spin} from "antd";

export default (loader) => {
    return Loadable({
        loader,
        loading() {
            return <div className='zkloading'><Spin/></div>
        },
    });
}